import {DataTable, fullDateTime} from '@management-ui/core';
import {reverse} from 'named-urls';
import React, {useCallback, useContext, useMemo} from 'react';
import {useHistory} from 'react-router-dom';
import {ServiceContext} from '../../../../components/Services';
import routes from '../../../../routes';
import NewCompanyForm from '../../forms/NewCompanyForm';

export default function Table(
  {
    title = 'Companies',
    archive = false,
    canCreate = true,
    onSelect = null,
    options = {}
  }
) {
  // noinspection DuplicatedCode
  const services = useContext(ServiceContext);
  const history = useHistory();

  const handleSelect = useCallback((company) => {
    if (onSelect) {
      onSelect(company)
    } else {
      history.push(reverse(`${archive ? routes.archive.companies.detail : routes.companies.detail}`, {id: company.id}));
    }
  }, [history, archive, onSelect]);

  return (
    <DataTable
      title={title}
      options={{
        ...options,
        headerStyle: {background: 'white', position: 'sticky', top: 0},
        maxBodyHeight: 'calc(100vh - 280px)'
      }}
      columns={useMemo(() => [
        {title: 'Name', field: 'name'},
        {title: 'Telephone', field: 'phone'},
        {title: 'Website', field: 'website'},
        {title: 'Manufacturer?', field: 'is_manufacturer', render: data => data.is_manufacturer ? 'Yes' : 'No'},
        {title: 'Supplier?', field: 'is_supplier', render: data => data.is_supplier ? 'Yes' : 'No'},
        {title: 'Date Added', field: 'created_at', render: data => fullDateTime(data.created_at)},
        ...(archive ? [{title: 'Archived', field: 'deleted_at', render: data => fullDateTime(data.deleted_at)}] : [])
      ], [archive])}
      loadData={query => new Promise((resolve, reject) => {
        services.company.getTableCompanies(query, archive ? {archive: 'only'} : {})
          .then(response => {
            resolve({
              data: response.data, page: response.meta.current_page - 1, totalCount: response.meta.total
            });
          }).catch(() => {
          reject();
        });
      })}
      onRowClick={handleSelect}
      newForm={canCreate && !archive ? {
        title: 'Add New Company',
        render: (props) => <NewCompanyForm {...props}/>,
        onSaved: handleSelect
      } : null}
    />
  );
}
